export const countries = [
  { country: "Afghanistan", adjective: "Afghan" },
  { country: "Albania", adjective: "Albanian" },
  { country: "Algeria", adjective: "Algerian" },
  { country: "Andorra", adjective: "Andorran" },
  { country: "Angola", adjective: "Angolan" },
  { country: "Antigua and Barbuda", adjective: "Antiguan and Barbudan" },
  { country: "Argentina", adjective: "Argentine" },
  { country: "Armenia", adjective: "Armenian" },
  { country: "Australia", adjective: "Australian" },
  { country: "Austria", adjective: "Austrian" },
  { country: "Azerbaijan", adjective: "Azerbaijani" },
  { country: "Bahamas", adjective: "Bahamian" },
  { country: "Bahrain", adjective: "Bahraini" },
  { country: "Bangladesh", adjective: "Bangladeshi" },
  { country: "Barbados", adjective: "Barbadian" },
  { country: "Belarus", adjective: "Belarusian" },
  { country: "Belgium", adjective: "Belgian" },
  { country: "Belize", adjective: "Belizean" },
  { country: "Benin", adjective: "Beninese" },
  { country: "Bhutan", adjective: "Bhutanese" },
  { country: "Bolivia", adjective: "Bolivian" },
  { country: "Bosnia and Herzegovina", adjective: "Bosnian and Herzegovinian" },
  { country: "Botswana", adjective: "Botswanan" },
  { country: "Brazil", adjective: "Brazilian" },
  { country: "Brunei", adjective: "Bruneian" },
  { country: "Bulgaria", adjective: "Bulgarian" },
  { country: "Burkina Faso", adjective: "Burkinabe" },
  { country: "Burundi", adjective: "Burundian" },
  { country: "Cabo Verde", adjective: "Cape Verdean" },
  { country: "Cambodia", adjective: "Cambodian" },
  { country: "Cameroon", adjective: "Cameroonian" },
  { country: "Canada", adjective: "Canadian" },
  { country: "Central African Republic", adjective: "Central African" },
  { country: "Chad", adjective: "Chadian" },
  { country: "Chile", adjective: "Chilean" },
  { country: "China", adjective: "Chinese" },
  { country: "Colombia", adjective: "Colombian" },
  { country: "Comoros", adjective: "Comorian" },
  { country: "Congo", adjective: "Congolese" },
  { country: "Costa Rica", adjective: "Costa Rican" },
  { country: "Croatia", adjective: "Croatian" },
  { country: "Cuba", adjective: "Cuban" },
  { country: "Cyprus", adjective: "Cypriot" },
  { country: "Czech Republic", adjective: "Czech" },
  { country: "Denmark", adjective: "Danish" },
  { country: "Djibouti", adjective: "Djiboutian" },
  { country: "Dominica", adjective: "Dominican" },
  { country: "Dominican Republic", adjective: "Dominican" },
  { country: "East Timor", adjective: "East Timorese" },
  { country: "Ecuador", adjective: "Ecuadorian" },
  { country: "Egypt", adjective: "Egyptian" },
  { country: "El Salvador", adjective: "Salvadoran" },
  { country: "Equatorial Guinea", adjective: "Equatorial Guinean" },
  { country: "Eritrea", adjective: "Eritrean" },
  { country: "Estonia", adjective: "Estonian" },
  { country: "Eswatini", adjective: "Swazi" },
  { country: "Ethiopia", adjective: "Ethiopian" },
  { country: "Fiji", adjective: "Fijian" },
  { country: "Finland", adjective: "Finnish" },
  { country: "France", adjective: "French" },
  { country: "Gabon", adjective: "Gabonese" },
  { country: "Gambia", adjective: "Gambian" },
  { country: "Georgia", adjective: "Georgian" },
  { country: "Germany", adjective: "German" },
  { country: "Ghana", adjective: "Ghanaian" },
  { country: "Greece", adjective: "Greek" },
  { country: "Grenada", adjective: "Grenadian" },
  { country: "Guatemala", adjective: "Guatemalan" },
  { country: "Guinea", adjective: "Guinean" },
  { country: "Guinea-Bissau", adjective: "Bissau-Guinean" },
  { country: "Guyana", adjective: "Guyanese" },
  { country: "Haiti", adjective: "Haitian" },
  { country: "Honduras", adjective: "Honduran" },
  { country: "Hungary", adjective: "Hungarian" },
  { country: "Iceland", adjective: "Icelandic" },
  { country: "India", adjective: "Indian" },
  { country: "Indonesia", adjective: "Indonesian" },
  { country: "Iran", adjective: "Iranian" },
  { country: "Iraq", adjective: "Iraqi" },
  { country: "Ireland", adjective: "Irish" },
  { country: "Israel", adjective: "Israeli" },
  { country: "Italy", adjective: "Italian" },
  { country: "Ivory Coast", adjective: "Ivorian" },
  { country: "Jamaica", adjective: "Jamaican" },
  { country: "Japan", adjective: "Japanese" },
  { country: "Jordan", adjective: "Jordanian" },
  { country: "Kazakhstan", adjective: "Kazakh" },
  { country: "Kenya", adjective: "Kenyan" },
  { country: "Kiribati", adjective: "I-Kiribati" },
  { country: "Kuwait", adjective: "Kuwaiti" },
  { country: "Kyrgyzstan", adjective: "Kyrgyz" },
  { country: "Laos", adjective: "Lao" },
  { country: "Latvia", adjective: "Latvian" },
  { country: "Lebanon", adjective: "Lebanese" },
  { country: "Lesotho", adjective: "Basotho" },
  { country: "Liberia", adjective: "Liberian" },
  { country: "Libya", adjective: "Libyan" },
  { country: "Liechtenstein", adjective: "Liechtensteiner" },
  { country: "Lithuania", adjective: "Lithuanian" },
  { country: "Luxembourg", adjective: "Luxembourger" },
  { country: "Madagascar", adjective: "Malagasy" },
  { country: "Malawi", adjective: "Malawian" },
  { country: "Malaysia", adjective: "Malaysian" },
  { country: "Maldives", adjective: "Maldivian" },
  { country: "Mali", adjective: "Malian" },
  { country: "Malta", adjective: "Maltese" },
  { country: "Marshall Islands", adjective: "Marshallese" },
  { country: "Mauritania", adjective: "Mauritanian" },
  { country: "Mauritius", adjective: "Mauritian" },
  { country: "Mexico", adjective: "Mexican" },
  { country: "Micronesia", adjective: "Micronesian" },
  { country: "Moldova", adjective: "Moldovan" },
  { country: "Monaco", adjective: "Monacan" },
  { country: "Mongolia", adjective: "Mongolian" },
  { country: "Montenegro", adjective: "Montenegrin" },
  { country: "Morocco", adjective: "Moroccan" },
  { country: "Mozambique", adjective: "Mozambican" },
  { country: "Myanmar", adjective: "Burmese" },
  { country: "Namibia", adjective: "Namibian" },
  { country: "Nauru", adjective: "Nauruan" },
  { country: "Nepal", adjective: "Nepali" },
  { country: "Netherlands", adjective: "Dutch" },
  { country: "New Zealand", adjective: "New Zealander" },
  { country: "Nicaragua", adjective: "Nicaraguan" },
  { country: "Niger", adjective: "Nigerien" },
  { country: "Nigeria", adjective: "Nigerian" },
  { country: "North Korea", adjective: "North Korean" },
  { country: "North Macedonia", adjective: "Macedonian" },
  { country: "Norway", adjective: "Norwegian" },
  { country: "Oman", adjective: "Omani" },
  { country: "Pakistan", adjective: "Pakistani" },
  { country: "Palau", adjective: "Palauan" },
  { country: "Palestine", adjective: "Palestinian" },
  { country: "Panama", adjective: "Panamanian" },
  { country: "Papua New Guinea", adjective: "Papua New Guinean" },
  { country: "Paraguay", adjective: "Paraguayan" },
  { country: "Peru", adjective: "Peruvian" },
  { country: "Philippines", adjective: "Filipino" },
  { country: "Poland", adjective: "Polish" },
  { country: "Portugal", adjective: "Portuguese" },
  { country: "Qatar", adjective: "Qatari" },
  { country: "Romania", adjective: "Romanian" },
  { country: "Russia", adjective: "Russian" },
  { country: "Rwanda", adjective: "Rwandan" },
  { country: "Saint Kitts and Nevis", adjective: "Kittitian and Nevisian" },
  { country: "Saint Lucia", adjective: "Saint Lucian" },
  { country: "Saint Vincent and the Grenadines", adjective: "Vincentian" },
  { country: "Samoa", adjective: "Samoan" },
  { country: "San Marino", adjective: "Sammarinese" },
  { country: "Sao Tome and Principe", adjective: "Sao Tomean" },
  { country: "Saudi Arabia", adjective: "Saudi" },
  { country: "Senegal", adjective: "Senegalese" },
  { country: "Serbia", adjective: "Serbian" },
  { country: "Seychelles", adjective: "Seychellois" },
  { country: "Sierra Leone", adjective: "Sierra Leonean" },
  { country: "Singapore", adjective: "Singaporean" },
  { country: "Slovakia", adjective: "Slovak" },
  { country: "Slovenia", adjective: "Slovenian" },
  { country: "Solomon Islands", adjective: "Solomon Islander" },
  { country: "Somalia", adjective: "Somali" },
  { country: "South Africa", adjective: "South African" },
  { country: "South Korea", adjective: "South Korean" },
  { country: "South Sudan", adjective: "South Sudanese" },
  { country: "Spain", adjective: "Spanish" },
  { country: "Sri Lanka", adjective: "Sri Lankan" },
  { country: "Sudan", adjective: "Sudanese" },
  { country: "Suriname", adjective: "Surinamese" },
  { country: "Sweden", adjective: "Swedish" },
  { country: "Switzerland", adjective: "Swiss" },
  { country: "Syria", adjective: "Syrian" },
  { country: "Taiwan", adjective: "Taiwanese" },
  { country: "Tajikistan", adjective: "Tajik" },
  { country: "Tanzania", adjective: "Tanzanian" },
  { country: "Thailand", adjective: "Thai" },
  { country: "Togo", adjective: "Togolese" },
  { country: "Tonga", adjective: "Tongan" },
  { country: "Trinidad and Tobago", adjective: "Trinidadian and Tobagonian" },
  { country: "Tunisia", adjective: "Tunisian" },
  { country: "Turkey", adjective: "Turkish" },
  { country: "Turkmenistan", adjective: "Turkmen" },
  { country: "Tuvalu", adjective: "Tuvaluan" },
  { country: "Uganda", adjective: "Ugandan" },
  { country: "Ukraine", adjective: "Ukrainian" },
  { country: "United Arab Emirates", adjective: "Emirati" },
  { country: "United Kingdom", adjective: "British" },
  { country: "United States", adjective: "American" },
  { country: "Uruguay", adjective: "Uruguayan" },
  { country: "Uzbekistan", adjective: "Uzbek" },
  { country: "Vanuatu", adjective: "Ni-Vanuatu" },
  { country: "Vatican City", adjective: "Vatican" },
  { country: "Venezuela", adjective: "Venezuelan" },
  { country: "Vietnam", adjective: "Vietnamese" },
  { country: "Yemen", adjective: "Yemeni" },
  { country: "Zambia", adjective: "Zambian" },
  { country: "Zimbabwe", adjective: "Zimbabwean" }
  
];
